/* RESPONSIBLE TEAM: team-channels */
import type AdminComment from 'embercom/objects/inbox/renderable/admin-comment';
import type BotComment from 'embercom/objects/inbox/renderable/bot-comment';
import type CustomBot from 'embercom/objects/inbox/renderable/custom-bot';
import type Whatsapp from 'embercom/objects/inbox/renderable/whatsapp';

export type RenderableDataWithSendState = AdminComment | BotComment | CustomBot | Whatsapp;

export interface SendStateWireFormat {
  send_state: number;
  info_message: string;
  details?: string | null;
}

export default class SendState {
  readonly sendState: number;
  readonly infoMessage: string;
  readonly details?: string | null;

  constructor(sendState: number, infoMessage: string, details?: string | null) {
    this.sendState = sendState;
    this.infoMessage = infoMessage;
    this.details = details;
  }

  static deserialize(json: SendStateWireFormat): SendState {
    return new SendState(json.send_state, json.info_message, json.details);
  }
}
